import { render, staticRenderFns } from "./RestrictionsHistoryTable.vue?vue&type=template&id=c514cc9e&"
import script from "./RestrictionsHistoryTable.vue?vue&type=script&lang=js&"
export * from "./RestrictionsHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./RestrictionsHistoryTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports